/* eslint-disable */

import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.republica45.pt/api-gerencia/public",
  headers: {
    "content-type": "application/json",
    Authorization: "Basic YXBwX3VzZXI6ZTg2YXNkSy83NUozKXBZfnNefn5ed0w=",
  },
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
});

export default {
  // SIGN IN
  async login(data) {
    try {
      const res = await instance.post("/dashboard/login", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarDadosComparador(data) {
    try {
      const res = await instance.post("/clientes/comparador", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async registar(data) {
    try {
      const res = await instance.post("/dashboard/registo", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async listarConsumo(data) {
    try {
      const res = await instance.post("/dashboard/listar/consumo", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async listarRestaurantes(data) {
    try {
      const res = await instance.post("/dashboard/listar/restaurantes", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async criarEvento(data) {
    try {
      const res = await instance.post("/dashboard/criar/evento", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async listarRestaurante(data) {
    try {
      const res = await instance.post("/dashboard/listar/restaurante", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async listarVisitas(data) {
    try {
      const res = await instance.post("/dashboard/listar/visitas", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async listarEventos(data) {
    try {
      const res = await instance.post("/dashboard/listar/eventos", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async enviarNotificacoes(data) {
    try {
      const res = await instance.post("/dashboard/enviar/notificacoes", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarTodosCartoesCriados(data) {
    try {
      const res = await instance.post(
        "/dashboard/listar/cartoes/criados",
        data
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarTodosCartoesRestaurante(data) {
    try {
      const res = await instance.post(
        "/dashboard/listar/cartoes/restaurante",
        data
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  // APAGAR
  async pagamentoBasico(data) {
    try {
      const res = await instance.post("/pagamento/basico", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarReservas(data) {
    try {
      const res = await instance.post("/dashboard/reservas/listar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async aceitarReservas(data) {
    try {
      const res = await instance.post("/aceitar/reserva", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async adicioanrReservaBO(data) {
    try {
      const res = await instance.post("/inserir/reserva/backoffice", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async apagarReservas(data) {
    try {
      const res = await instance.post("/apagar/reserva", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async atualizarPerfilComerciante(data) {
    try {
      const res = await instance.post("/atualizar/perfil/comerciante", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async atualizarEstabelecimentoAPI(data) {
    try {
      const res = await instance.post("/atualizar/estabelecimento", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarFuncionariosEstabelecimento(data) {
    try {
      const res = await instance.post(
        "/dashboard/estabelecimento/detalhes",
        data
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async verificarToken(data) {
    try {
      const res = await instance.post("/verificar/transacao/token", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async tratarTransacao(data) {
    try {
      const res = await instance.post("/finalizar/transacao", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarPlanos(data) {
    try {
      const res = await instance.post("/listar/planos", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarComerciantes(data) {
    try {
      const res = await instance.post("/listar/comerciantes", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarUtilizadores(data) {
    try {
      const res = await instance.post("/dashboard/utilizadores/listar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async listarSubCategorias(data) {
    try {
      const res = await instance.get("/listar/subcategorias", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async enviarNotificacao(data) {
    try {
      const res = await instance.post("/enviarNotificacao", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async listarLeads(data) {
    try {
      const res = await instance.post("/dashboard/listar/leads", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async listarLeadsIncumprimento(data) {
    try {
      const res = await instance.post(
        "/dashboard/listar/leads/incumprimento",
        data
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async converterLead(data) {
    try {
      const res = await instance.post("/dashboard/converter/leads", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
};
